import { TechnologyPreview } from '@openshift-assisted/ui-lib/ocm';
import '../i18n';
export default TechnologyPreview;
